jQuery(document).ready(function($){
    $('.menu-item-has-children > a').on('click', function(e){
        
        e.preventDefault();
        $('.menu-item-has-children').removeClass('open');
        $(this).parent().toggleClass('open');
        $('.sub-menu').removeClass('opensub');
        $(this).parent().find('.sub-menu').toggleClass('opensub');
    });
});